/* */ 
module.exports = buildSearchMethod;
var errors = require('./errors');
function buildSearchMethod(queryParam, url) {
  return function search(query, args, callback) {
    if (typeof query === 'function' && typeof args === 'object' || typeof callback === 'object') {
      throw new errors.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
    }
    if (arguments.length === 0 || typeof query === 'function') {
      callback = query;
      query = '';
    } else if (arguments.length === 1 || typeof args === 'function') {
      callback = args;
      args = undefined;
    }
    if (typeof query === 'object' && query !== null) {
      args = query;
      query = undefined;
    } else if (query === undefined || query === null) {
      query = '';
    }
    var params = '';
    if (query !== undefined) {
      params += queryParam + '=' + encodeURIComponent(query);
    }
    var additionalUA;
    if (args !== undefined) {
      if (args.additionalUA) {
        additionalUA = args.additionalUA;
        delete args.additionalUA;
      }
      params = this.as._getSearchParams(args, params);
    }
    return this._search(params, url, callback, additionalUA);
  };
}
